import { GET_FILE_TYPE, GET_FILE_UPLOAD_LOGS, GET_RESE_CUSTOM_FILE_NAME ,GET_RESE_CUSTOM_FILE_CONTENT } from "./actionTypes";

export const getFileTypeInit = () => ({
    type: GET_FILE_TYPE.INIT,
});

export const getFileTypeSuccess = (fileTypeList) => ({
    type: GET_FILE_TYPE.SUCCESS,
    payload: fileTypeList,
});

export const getFileTypeFailure = (errroMessage) => ({
    type: GET_FILE_TYPE.ERROR,
    payload: errroMessage,
});

export const getReseFileuploadLogsInit = () => ({
    type: GET_FILE_UPLOAD_LOGS.INIT,
});

export const getReseFileuploadLogsSuccess = (uploadLogs) => ({
    type: GET_FILE_UPLOAD_LOGS.SUCCESS,
    payload: uploadLogs,
});

export const getReseFileuploadLogsFailure = (errroMessage) => ({
    type: GET_FILE_UPLOAD_LOGS.ERROR,
    payload: errroMessage,
});

export const getReseCustomFileNameInit = (customFileNamePayload) => ({
    type: GET_RESE_CUSTOM_FILE_NAME.INIT,
    customFileNamePayload
});

export const getReseCustomFileNameSuccess = (reseCustomFileNameData) => ({
    type: GET_RESE_CUSTOM_FILE_NAME.SUCCESS,
    payload: reseCustomFileNameData
});

export const getReseCustomFileNameError = (error) => ({
    type: GET_RESE_CUSTOM_FILE_NAME.ERROR,
    payload: error
});

export const getReseCustomFileContentInit = (selectedFileTypeName,store,driverConfigFileType) => ({
    type: GET_RESE_CUSTOM_FILE_CONTENT.INIT,
    selectedFileTypeName, store,driverConfigFileType
});

export const getReseDriverConfigFileContentSuccess = (customFileContent) => ({
    type: GET_RESE_CUSTOM_FILE_CONTENT.SUCCESS,
    payload: customFileContent
});

export const getReseDriverConfigFileContentError = (error) => ({
    type: GET_RESE_CUSTOM_FILE_CONTENT.ERROR,
    payload: error
});